"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    styledBox: {
        display: 'flex',
        flexDirection: 'column'
    },
    styledText: {
        lineHeight: 'normal',
        fontWeight: 'bolder'
    },
    styledDiv: {
        marginBottom: 10,
        fontSize: 12,
        color: theme.grey2
    },
    descriptionMarkdown: {
        lineHeight: 1.4,
        fontSize: 12,
        '&:first-child': {
            marginTop: 0
        },
        '&:last-child': {
            marginBottom: 0
        }
    }
});
//# sourceMappingURL=objectField.style.js.map